import ACTIONS from "../../constatnts"

export const setSpinner = payload => ({
  type: ACTIONS.SET_SPINNER,
  payload,
})
